import * as d3 from 'd3';
import d3tip from "d3-tip";

window.onload = function () {
  let data = [
    { "orientation": "Heterosexual", "count": 2526 },
    { "orientation": "Bisexual", "count": 488 },
    { "orientation": "Lesbian/Gay", "count": 202 },
    { "orientation": "Questioning", "count": 103 },
    { "orientation": "Pansexual", "count": 83 },
    { "orientation": "Asexual", "count": 56 },
    { "orientation": "Other", "count": 47 },
  ];

  let total = d3.sum(data, d => d.count);

  for (let i = 0; i < data.length; i++) {
    data[i].percent = data[i].count / total * 100;
  }

  let margin = { top: 20, right: 20, bottom: 40, left: 20 }
  let width = document.querySelector('.vis').clientWidth - margin.left - margin.right
  let height = 400 - margin.top - margin.bottom

  let svg = d3.select('.figure__graphic')
    .append('svg')
    .attr('width', width + margin.left + margin.right)
    .attr('height', height + margin.top + margin.bottom)
    .append('g')
    .attr('transform', `translate(${margin.left}, ${margin.top})`);

  let xOffset;

  let y = d3.scaleBand()
    .domain(data.map(d => d.orientation))
    .range([0, height])
    .padding(0.1)

  let yAxis = d3.axisLeft(y);

  let customYAxis = g => {
    g.call(yAxis);
    g.select('.domain').remove();
    g.selectAll('text')
      .attr('class', 'text')
      .style('text-anchor', 'end')
      .style('font-size', '1em')
    g.selectAll('.tick line').remove();
  }

  let yAxisContainer = svg.append('g')
    .attr('class', 'axis')
    .call(customYAxis);

  let setLongestLabelLength = g => {
    let max = 0;
    g.each(function () {
      let n = d3.select(this);
      let l = n.node().getComputedTextLength();
      if (l > max) {
        max = l;
      }
    });
    xOffset = max;
  }

  svg.selectAll('.text')
    .call(setLongestLabelLength)

  yAxisContainer
    .attr('transform', `translate(${xOffset}, ${0})`)

  let x = d3.scaleLinear()
    .domain([0, Math.ceil(d3.max(data, d => d.percent) / 10) * 10])
    .range([xOffset, width])

  let xAxis = d3.axisBottom(x)
    .tickSize(height)
    .tickFormat(d => `\xa0${d}%`);

  let customXAxis = g => {
    let s = g.selection ? g.selection() : g;
    g.call(xAxis);
    g.selectAll('text')
      .attr('class', 'text bottom-text')
      .attr('font-size', '1.1em')
    s.select('.domain').remove();
    s.select('.tick line').remove();
    s.selectAll('.tick line').filter(Number)
      .attr('stroke', '#d8d8d8')
      .attr('stroke-dasharray', '2,2');
    s.selectAll('.tick text')
      .attr('x', 0)
      .attr('dy', 10);
    if (s !== g) {
      g.selectAll('.tick text')
        .attrTween('x', null)
        .attrTween('dy', null);
    }
  }

  svg.append('g')
    .call(customXAxis);

  let tip = d3tip()
    .attr('class', 'd3-tip')
    .offset([-10, 0])
    .html((e, d) => `${parseFloat(d.percent).toFixed(2)}%`)

  svg.call(tip);

  svg.selectAll('.bar')
    .data(data)
    .join('rect')
    .attr('x', xOffset)
    .attr('y', d => y(d.orientation))
    .attr('height', y.bandwidth())
    .attr('width', d => x(d.percent) - xOffset)
    .attr('fill', '#f065a5')
    .on('mousemove', tip.show)
    .on('mouseout', tip.hide)
    .attr('class', 'bar')
}
